export const SYSTEM_NUMBER = `
   id
   active
   phoneNumber
`

export const PHONE_NUMBER = `
   phoneNumber
`
